import React, { useState, useEffect } from 'react'
import NavigationSecurity from '../Layouts/Navigation/NavigationSecurity'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt, faUserCheck, faBoxOpen, faCar, faParking } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { BASE_URL } from '../utils/constants';
import { useNavigate } from 'react-router-dom';

function IndexSecurity() {
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    visitas_atendidas: 0,
    paquetes_recibidos: 0,
    espacios_visitantes: {
      total_disponibles: 0,
      carros_disponibles: 0,
      carros_total: 0,
      motos_disponibles: 0,
      motos_total: 0
    },
    espacios_residentes: {
      total: 0,
      disponibles: 0,
      ocupados: 0
    }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardStats();
  }, []);

  const fetchDashboardStats = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/securityDashboardStats`);
      // Asegurar que los campos numéricos sean Number para evitar concatenación de strings
      const data = response.data || {};
      const ev = data.espacios_visitantes || {};
      const rv = data.espacios_residentes || {};
      const parsed = {
        visitas_atendidas: Number(data.visitas_atendidas) || 0,
        paquetes_recibidos: Number(data.paquetes_recibidos) || 0,
        espacios_visitantes: {
          total_disponibles: Number(ev.total_disponibles) || ((Number(ev.carros_disponibles) || 0) + (Number(ev.motos_disponibles) || 0)),
          carros_disponibles: Number(ev.carros_disponibles) || 0,
          carros_total: Number(ev.carros_total) || 0,
          motos_disponibles: Number(ev.motos_disponibles) || 0,
          motos_total: Number(ev.motos_total) || 0
        },
        espacios_residentes: {
          total: Number(rv.total) || 0,
          disponibles: Number(rv.disponibles) || 0,
          ocupados: Number(rv.ocupados) || 0
        }
      };
      setStats(parsed);
      setLoading(false);
    } catch (error) {
      console.error('Error al cargar estadísticas:', error);
      setLoading(false);
    }
  };

  return (
    <>
      <NavigationSecurity/>
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 p-4 sm:p-6 lg:p-8">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="bg-white rounded-2xl shadow-lg p-8 mb-8 transform hover:shadow-2xl transition-all duration-300">
            <div className="flex items-center justify-center mb-6">
              <div className="p-4 bg-gradient-to-br from-security-500 to-security-700 rounded-full shadow-lg">
                <FontAwesomeIcon icon={faShieldAlt} className="h-16 w-16 text-white" />
              </div>
            </div>
            <h1 className="text-4xl font-bold text-gray-800 text-center mb-4">
              Panel de Seguridad
            </h1>
            <p className="text-lg text-gray-600 text-center">
              Estadísticas y control de acceso
            </p>
          </div>

          {/* Dashboard Cards */}
          {loading ? (
            <div className="text-center py-12">
              <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-security-600"></div>
              <p className="mt-4 text-gray-600">Cargando estadísticas...</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {/* Card 1: Visitas Atendidas */}
              <div 
                onClick={() => navigate('/visitControl')}
                className="bg-white rounded-xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-green-500 cursor-pointer hover:shadow-2xl"
              >
                <div className="flex items-center justify-between mb-4">
                  <div className="p-3 bg-gradient-to-br from-green-400 to-green-600 rounded-lg">
                    <FontAwesomeIcon icon={faUserCheck} className="h-8 w-8 text-white" />
                  </div>
                </div>
                <h3 className="text-gray-500 text-sm font-semibold uppercase mb-2">
                  Visitas Atendidas
                </h3>
                <p className="text-3xl font-bold text-gray-800 mb-1">
                  {stats.visitas_atendidas}
                </p>
                <p className="text-xs text-gray-500">Últimos 7 días</p>
              </div>

              {/* Card 2: Paquetes Recibidos */}
              <div 
                onClick={() => navigate('/packageControl')}
                className="bg-white rounded-xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-amber-500 cursor-pointer hover:shadow-2xl"
              >
                <div className="flex items-center justify-between mb-4">
                  <div className="p-3 bg-gradient-to-br from-amber-400 to-amber-600 rounded-lg">
                    <FontAwesomeIcon icon={faBoxOpen} className="h-8 w-8 text-white" />
                  </div>
                </div>
                <h3 className="text-gray-500 text-sm font-semibold uppercase mb-2">
                  Paquetes Recibidos
                </h3>
                <p className="text-3xl font-bold text-gray-800 mb-1">
                  {stats.paquetes_recibidos}
                </p>
                <p className="text-xs text-gray-500">Últimos 7 días</p>
              </div>

              {/* Card 3: Espacios Visitantes */}
              <div 
                onClick={() => navigate('/securityParking')}
                className="bg-white rounded-xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-blue-500 cursor-pointer hover:shadow-2xl"
              >
                <div className="flex items-center justify-between mb-4">
                  <div className="p-3 bg-gradient-to-br from-blue-400 to-blue-600 rounded-lg">
                    <FontAwesomeIcon icon={faCar} className="h-8 w-8 text-white" />
                  </div>
                </div>
                <h3 className="text-gray-500 text-sm font-semibold uppercase mb-2">
                  Espacios Visitantes
                </h3>
                <p className="text-3xl font-bold text-gray-800 mb-1">
                  {stats.espacios_visitantes.total_disponibles}
                </p>
                <p className="text-xs text-gray-500 mb-3">Disponibles</p>
                <div className="flex justify-between text-xs text-gray-600 border-t pt-2">
                  <span>🚗 Carros: {stats.espacios_visitantes.carros_disponibles}/{stats.espacios_visitantes.carros_total}</span>
                  <span>🏍️ Motos: {stats.espacios_visitantes.motos_disponibles}/{stats.espacios_visitantes.motos_total}</span>
                </div>
              </div>

              {/* Card 4: Espacios Residentes */}
              <div 
                onClick={() => navigate('/securityParking')}
                className="bg-white rounded-xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-purple-500 cursor-pointer hover:shadow-2xl"
              >
                <div className="flex items-center justify-between mb-4">
                  <div className="p-3 bg-gradient-to-br from-purple-400 to-purple-600 rounded-lg">
                    <FontAwesomeIcon icon={faParking} className="h-8 w-8 text-white" />
                  </div>
                </div>
                <h3 className="text-gray-500 text-sm font-semibold uppercase mb-2">
                  Espacios Residentes
                </h3>
                <p className="text-3xl font-bold text-gray-800 mb-1">
                  {stats.espacios_residentes.total}
                </p>
                <p className="text-xs text-gray-500 mb-3">Total de espacios</p>
                <div className="flex justify-between text-xs text-gray-600 border-t pt-2">
                  <span className="text-green-600">Disponibles: {stats.espacios_residentes.disponibles}</span>
                  <span className="text-red-600">Ocupados: {stats.espacios_residentes.ocupados}</span>
                </div>
              </div>
            </div>
          )}

          {/* Summary Section */}
          {!loading && (
            <div className="mt-8 bg-white rounded-xl shadow-lg p-6">
              <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
                <FontAwesomeIcon icon={faShieldAlt} className="mr-3 text-security-600" />
                Resumen Operacional
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-700">
                <div className="p-4 bg-gray-50 rounded-lg">
                  <p className="font-semibold text-security-700 mb-2">Control de Acceso</p>
                  <p className="text-sm">✓ {stats.visitas_atendidas} visitas procesadas exitosamente en la última semana</p>
                </div>
                <div className="p-4 bg-gray-50 rounded-lg">
                  <p className="font-semibold text-security-700 mb-2">Gestión de Paquetería</p>
                  <p className="text-sm">✓ {stats.paquetes_recibidos} paquetes registrados en la última semana</p>
                </div>
                <div className="p-4 bg-gray-50 rounded-lg">
                  <p className="font-semibold text-security-700 mb-2">Capacidad de Parqueadero</p>
                  <p className="text-sm">✓ {stats.espacios_residentes.disponibles} de {stats.espacios_residentes.total} espacios disponibles para residentes</p>
                </div>
                <div className="p-4 bg-gray-50 rounded-lg">
                  <p className="font-semibold text-security-700 mb-2">Parqueadero Visitantes</p>
                  <p className="text-sm">✓ {stats.espacios_visitantes.total_disponibles} espacios disponibles ({stats.espacios_visitantes.carros_disponibles} carros, {stats.espacios_visitantes.motos_disponibles} motos)</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default IndexSecurity